import { render } from "./tableHead.vue?vue&type=template&id=f18d68c2"
import script from "./tableHead.vue?vue&type=script&lang=js"
export * from "./tableHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__